import { render } from "./CreateUnitModal.vue?vue&type=template&id=19acbf27"
import script from "./CreateUnitModal.vue?vue&type=script&lang=js"
export * from "./CreateUnitModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__